.breadcrumb {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  font-family: 'Lato';
  font-weight: 400;

  .breadcrumb-item {
    margin-right: 0.5rem;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      font-weight: bold;
    }

    a {
      color: #333;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    &::after {
      content: '/';
      margin-left: 0.5rem;
      color: #999;
    }

    &:last-child::after {
      content: '';
      margin-left: 0;
    }
  }
}
